export enum LOBproductConfigEnum{
    health="49f3f7ad-4942-476e-9473-5f2f35a86a54",
    fireAndLightening = "b4eb7123-04be-4d26-b1e2-7a76bd382085",
    motor = "49f3f7ad-4942-476e-9473-5f2f35a86a52",
    life = "502ef2cf-2d5a-4dc8-91fa-8c8086b94192",
    workmen = "d02a6218-7e41-41db-9be4-98f5cf4b751d",
    travel = "a77cf4c2-0fc4-4ce2-946d-bca13af2e09c",
    groupPersonalAccident = "f6c66275-0a0d-417c-913f-be541ed1b0a1",
    engineering = "a51d96a2-fab6-4b46-8bec-663cc350d2c0"
}